import React from 'react';

import "./quiz.css";

const Footer = () => {
    return (
        <footer className='quiz-footer'>
            <div className='heading'>QuizBuzz</div>
        </footer>
    )
}

export default Footer;
